import React from 'react'
import { TitleCompanyCreation } from './components/TitleCompanyCreation'

const TitleCompany = () => {
  return (
    <TitleCompanyCreation/>
  )
}

export {TitleCompany}